/* eslint-disable max-len */
import * as React from 'react';

const Dashboard = (props) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25 6C3.25 4.48122 4.48122 3.25 6 3.25H20C21.5188 3.25 22.75 4.48122 22.75 6V20C22.75 21.5188 21.5188 22.75 20 22.75H6C4.48122 22.75 3.25 21.5188 3.25 20V6ZM6 4.75C5.30964 4.75 4.75 5.30964 4.75 6V20C4.75 20.6904 5.30964 21.25 6 21.25H13L13 4.75H6ZM14.5 4.75V11.5H21.25V6C21.25 5.30964 20.6904 4.75 20 4.75H14.5ZM21.25 13H14.5L14.5 21.25H20C20.6904 21.25 21.25 20.6904 21.25 20V13Z"
      fill="#D1D1D1"
    />
  </svg>
);

export default Dashboard;
